/* src/app/components/account/archive-job/archive-jobs.component.scss */
.status-action {
  display: flex;
  align-items: center;
  gap: 15px;
  padding-right: 20px;
}
.fa-ban {
  color: grey;
}
.fa-play {
  color: #2B9222;
}
.comments {
  color: gray;
}
:host-context(.dark-theme) .mat-mdc-card {
  background: #2c2c2c;
}
:host-context(.dark-theme) .fa-ban {
  color: rgba(255, 255, 255, 0.7);
}
:host-context(.dark-theme) .fa-play {
  color: #45b549;
}
:host-context(.dark-theme) .comments {
  color: rgba(255, 255, 255, 0.6);
}
/*# sourceMappingURL=archive-jobs.component.css.map */
